import { ILoginResponse, RegistrationErrorType, RegistrationRequestType, iAuthStorage, iLoginData, iLoginRequest, iSoftAuthStorage } from "../helpers/interfaces/auth";
import axios, { BASE_API_URL } from "./Api";
import { AxiosError, AxiosResponse } from "axios";

export const authStorageKey = "C5Auth";
const softTokenStorageKey = 'C5SoftToken';

export function getAuth(): iAuthStorage {
    let authStorage = localStorage.getItem(authStorageKey);
    return authStorage ? JSON.parse(authStorage) : null
}

export function getSoftToken(): iSoftAuthStorage {
    return localStorage.getItem(softTokenStorageKey);
}

export async function login(body: iLoginRequest): Promise<iLoginData> {
    return await axios.post(BASE_API_URL + "?op=login", body)
        .then((response: AxiosResponse<ILoginResponse | number>) => {
            if (typeof response.data === 'number') {
                return Promise.reject('Invalid login data');
            }

            return response.data.data
        }).catch((reason: any) => {
            return Promise.reject('Invalid login data');
        });
}

export async function logout(): Promise<void> {
    localStorage.removeItem(authStorageKey);
}

export async function removeSoftToken(): Promise<void> {
    localStorage.removeItem(softTokenStorageKey);
}

export async function softLogin(): Promise<string> {
    await logout();
    const softUser = await login({
        email: '',
        password: ''
    });

    localStorage.setItem(softTokenStorageKey, softUser.token);

    return softUser.token;
}

export async function registration(body: RegistrationRequestType): Promise<iLoginData> {
    return await axios.post(BASE_API_URL + "?op=invioRegistrazione", body)
        .then((response: AxiosResponse<any>) => {
            return response.data.data
        }).catch((reason: AxiosError<RegistrationErrorType>) => {
            return Promise.reject(reason.response?.data.data);
        });
}

export async function activeUser(
    userId: string,
    activeCode: string
): Promise<void> {
    return await axios.post(
        BASE_API_URL + "?op=attivaUtente&idUtente=" + userId + "&code=" + activeCode
    ).then((response: AxiosResponse<{data: any}>) => {
        if (response.data.data === 0) {
            return Promise.reject(
                new Error(
                    'Impossibile attivare l\'utente, per favore verifica i dati e riprova'
                )
            );
        }

        return Promise.resolve();
    }).catch((reason: any) => {
        return Promise.reject(
            new Error(
                'Si è verificato un errore durante l\'attivazione dell\'utente'
            )
        );
    });
}